import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    borderTop: '0.0625rem solid rgba(230, 234, 236, 0.9)',
    borderBottom: '0.0625rem solid rgba(230, 234, 236, 0.9)',

    '& .children': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '1rem',

      '& > :not(:last-child)': {
        marginRight: '0.5rem'
      },

      [theme.breakpoints.down('md')]: {
        display: 'grid !important',
        gridTemplateRows: 'repeat(3, 25px)'
      }
    }
  },

  smallRoot: {
    '& .children': {
      marginRight: '0',

      '& > :not(:last-child)': {
        marginRight: '0'
      },

      '& > div': {
        paddingRight: '1.125rem'
      }
    }
  }
}))

export default useStyles
